/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Notifications_viewer = {
    readonly regInfo?: ReadonlyArray<{
        readonly countryCode: string | null;
    } | null> | null;
    readonly isAutomatedOfferNotificationDisabled: boolean | null;
    readonly conversations?: {
        readonly " $fragmentRefs": FragmentRefs<"Conversations_conversations">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"ActivityFeed_viewer">;
    readonly " $refType": "Notifications_viewer";
};
export type Notifications_viewer$data = Notifications_viewer;
export type Notifications_viewer$key = {
    readonly " $data"?: Notifications_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"Notifications_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "Notifications_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "first",
      "type": "Int",
      "defaultValue": 5
    },
    {
      "kind": "LocalArgument",
      "name": "fetchNotifications",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "hasSessionCountryCode",
      "type": "Boolean!",
      "defaultValue": false
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isAutomatedOfferNotificationDisabled",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "disableAutomatedOfferBellNotification"
        }
      ],
      "storageKey": "isEnabled(key:\"disableAutomatedOfferBellNotification\")"
    },
    {
      "kind": "Condition",
      "passingValue": false,
      "condition": "hasSessionCountryCode",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "regInfo",
          "name": "regionalInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "RegionalInfo",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "countryCode",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchNotifications",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "conversations",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": "showUnreadOnly"
            },
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "first"
            },
            {
              "kind": "Literal",
              "name": "notifications",
              "value": true
            }
          ],
          "concreteType": "ConversationConnection",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "Conversations_conversations",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ActivityFeed_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'f8a17506ddec62d348ba6edc0fe692be';
export default node;
